
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.31010',
  depVersions: {
  "feedback-public-submission-ui": "static-1.31010",
  "emoji-mart": "static-3.7",
  "feedback-schema": "static-1.55594",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8507",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11959",
  "I18n": "static-7.1706",
  "quartz": "static-1.7648",
  "quartz-config": "static-1.1426",
  "quartz-core": "static-1.6867",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1094",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55581",
  "feedback-utils": "static-1.55585",
  "forms-embed-utils-lib": "static-1.4930",
  "forms-utils-lib": "static-1.13329",
  "foundations-assets": "static-1.5356",
  "foundations-components": "static-1.8742",
  "foundations-theming": "static-1.4959",
  "hub-http": "static-1.6678",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12266",
  "icons": "static-2.702",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4229",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17204",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5654",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.518",
  "tinymce-plugins": "static-1.58501",
  "transmute": "static-2.97",
  "ui-images": "static-2.1276",
  "UIComponents": "static-3.8905",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3925",
  "quartz-webpack": "static-1.3872",
  "foundations-theming-specialty": "static-1.2675",
  "property-description-translator": "static-1.4290",
  "HeadJS": "static-2.820",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3618",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4780",
  "jasmine-runner": "static-1.6922",
  "opentelemetry-fe-types": "static-1.262",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.905",
  "hubspotter-http": "static-1.4973",
  "mobile-manifest-mixins": "static-1.604",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.637",
  "quartz-auth": "static-1.1323",
  "quartz-head": "static-1.1313",
  "quartz-i18n": "static-1.1323",
  "quartz-routing": "static-1.1078",
  "quartz-test": "static-1.1323",
  "quartz-tracking": "static-1.1027",
  "trellis-components": "static-1.3088",
  "ui-fonts": "static-1.1221",
  "usage-tracker-container": "static-1.7783",
  "usage-tracker-core": "static-1.7643",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.359",
  "conversations-skeleton-state": "static-1.7607",
  "reference-resolvers": "static-1.8652",
  "sanitize-text": "static-1.8629",
  "PatternValidationJS": "static-1.3356",
  "ReduxMessenger": "static-2.10840",
  "outpost": "static-1.4600",
  "rpc-client-utils": "static-1.5141",
  "sanitize": "static-1.4944",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5011",
  "floating-ui": "static-1.68",
  "hs-story-utils": "static-1.9894",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.101",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3069",
  "bend-plugin-foundations-theming": "static-1.3442",
  "foundations-theming-base": "static-1.3944",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.398",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.171",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.10009",
  "atom": "static-1.5543",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8415",
  "ContentUtils": "static-1.69459",
  "data-token-picker": "static-1.17126",
  "file-manager-components": "static-1.24827",
  "FileManagerCore": "static-1.40326",
  "FileManagerLib": "static-1.40467",
  "frontend-preferences-client": "static-1.8391",
  "hub-http-contrib": "static-1.3501",
  "interframe": "static-3.5211",
  "layout-dnd-components": "static-1.13219",
  "layout-dnd-utils": "static-1.12194",
  "property-translator": "static-1.5850",
  "react-codemirror": "static-1.11111",
  "react-colorpicker": "static-2.10680",
  "reference-resolvers-lite": "static-1.8580",
  "rich-text-lib": "static-1.20544",
  "tinymce-data": "static-1.41472",
  "tinymce-themes": "static-1.57357",
  "ui-addon-emoji-picker": "static-1.10333",
  "ui-addon-sales-email": "static-1.5673",
  "ui-brand-identity-lib": "static-1.16931",
  "bender-build-tools": "static-1.3567",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10892",
  "hubspotter-http-shared-msw-handlers": "static-1.10890",
  "usage-tracker-session-replay": "static-1.5479",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "trellis-theming": "static-1.1469",
  "tanstack-virtual": "static-1.43",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.551",
  "chirp-fetch": "static-1.2374",
  "stylex-utils": "static-1.173",
  "chatspot-core": "static-1.23837",
  "copilot-toolkit": "static-1.12136",
  "customer-data-objects-ui-components": "static-1.13505",
  "data-fetching-client": "static-1.10110",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5229",
  "ui-addon-video-player": "static-1.9093",
  "ui-coaching-tips": "static-1.29579",
  "usage-tracker": "static-1.7793",
  "cms-field-types": "static-1.5282",
  "content-icons-ui": "static-1.2453",
  "integrations-lib": "static-1.17420",
  "customer-data-objects": "static-1.8172",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2145",
  "apollo-link-hub-http": "static-2.5058",
  "apollo-stack-hubspot": "static-3.99",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4613",
  "poll-commands": "static-1.3947",
  "ui-addon-iframeable": "static-1.9545",
  "video-components-external": "static-1.12420",
  "video-data-lib": "static-1.36078",
  "audio-components": "static-1.6562",
  "breeze-artifacts-sdk": "static-1.924",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30053",
  "FileManagerImages": "static-1.37978",
  "foundations-components-legacy": "static-1.1767",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.728",
  "ui-universal-auth": "static-1.9727",
  "urlinator": "static-1.4986",
  "video-components": "static-1.14422",
  "video-embed": "static-1.36912",
  "ts-schema": "static-1.4391",
  "ContentData": "static-1.69534",
  "layout-data-lib": "static-1.10519",
  "react-dnd-compat": "static-1.5082",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2017",
  "external-options-client-types": "static-1.4438",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6063",
  "hs-resources": "static-1.664",
  "inbound-db-properties-service-client": "static-1.4150",
  "NamespacedHubStyle": "static-2.9365",
  "growth-onboarding-confetti": "static-1.3531",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11618",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5904",
  "magpie-types": "static-1.5364",
  "simple-logging-lib": "static-1.3522",
  "avatar-components": "static-1.2957",
  "customer-data-ui-utilities": "static-1.10306",
  "growth-onboarding-feedback-components": "static-1.7054",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5351",
  "integrations-error-boundary-lib": "static-1.14835",
  "integrations-tracking-lib": "static-1.6090",
  "laboratory-lib": "static-3.7618",
  "native-integrations-shared-strings": "static-1.8233",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10748",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1123",
  "breeze-engine-core": "static-1.1423",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1117",
  "navigation-messaging": "static-1.8484",
  "content-media-composition-data-lib": "static-1.13582",
  "content-media-compositions": "static-2.17589",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19632",
  "nudge-client-utils": "static-1.3411",
  "custom-vendor-connection-lib": "static-1.291",
  "unified-auth-core-lib": "static-1.1523",
  "social-insights-client-types": "static-1.22918",
  "advanced-menus-core": "static-1.15809",
  "advanced-menus-lib": "static-1.12565",
  "ExportDialog": "static-6.10842",
  "ui-memberships-settings-lib": "static-1.35171",
  "conditional-properties-service-client": "static-1.4111",
  "crm-pipelines-api-client-types": "static-1.4441",
  "event-emitter": "static-1.1433",
  "fdsr-migration-layer": "static-1.482",
  "framework-builder-read-service-client": "static-1.4333",
  "inbound-db-meta-service-client": "static-1.3773",
  "multi-currency-client-types": "static-1.4006",
  "foundations-components-test-utils": "static-1.6225",
  "reactive-lib": "static-1.1191",
  "trellis-migration-context": "static-1.49",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.810",
  "universal-page-editor-lib": "static-1.3481",
  "bend-plugin-pulse": "static-1.620",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30794",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3168",
  "nudge-renderer-utils": "static-1.3487",
  "onboarding-tours": "static-1.17393",
  "whisper-core-api": "static-1.7625",
  "fsm": "static-1.4230",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15808",
  "simple-menus-lib": "static-1.17325",
  "settings-ui-lib": "static-1.12999",
  "persist-promise": "static-1.4174",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7363",
  "location-customization-utils-lib": "static-1.10406",
  "getting-started-shared-tasks": "static-1.19552",
  "growth-data-modal": "static-1.6128",
  "growth-onboarding-next-action-utils": "static-1.2974",
  "navigation-components": "static-1.19157",
  "nest": "static-1.706",
  "onboarding-tours-client": "static-1.5608",
  "onboarding-tours-utils": "static-1.1460",
  "ui-shepherd-tracker": "static-1.8129",
  "user-context": "static-1.5524",
  "react-flip-move": "static-1.83",
  "framework-data-schema-quick-fetch": "static-1.7268",
  "onboarding-data-sync-lib": "static-1.2834",
  "growth-onboarding-next-action-components": "static-1.3002",
  "user-context-client": "static-1.4981",
  "getting-started-shared-tasks-store": "static-1.18670",
  "InboxConnectUtils": "static-4.15834",
  "meetings-connect-utils-lib": "static-1.8088",
  "onboarding-scopes": "static-1.6923"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31010",
  "emoji-mart": "/emoji-mart/static-3.7",
  "feedback-schema": "/feedback-schema/static-1.55594",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8507",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11959",
  "I18n": "/I18n/static-7.1706",
  "quartz": "/quartz/static-1.7648",
  "quartz-config": "/quartz-config/static-1.1426",
  "quartz-core": "/quartz-core/static-1.6867",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1094",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55581",
  "feedback-utils": "/feedback-utils/static-1.55585",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4930",
  "forms-utils-lib": "/forms-utils-lib/static-1.13329",
  "foundations-assets": "/foundations-assets/static-1.5356",
  "foundations-components": "/foundations-components/static-1.8742",
  "foundations-theming": "/foundations-theming/static-1.4959",
  "hub-http": "/hub-http/static-1.6678",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12266",
  "icons": "/icons/static-2.702",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4229",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17204",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5654",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tinymce-plugins": "/tinymce-plugins/static-1.58501",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1276",
  "UIComponents": "/UIComponents/static-3.8905",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3925",
  "quartz-webpack": "/quartz-webpack/static-1.3872",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2675",
  "property-description-translator": "/property-description-translator/static-1.4290",
  "HeadJS": "/HeadJS/static-2.820",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3618",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4780",
  "jasmine-runner": "/jasmine-runner/static-1.6922",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.262",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hubspotter-http": "/hubspotter-http/static-1.4973",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.604",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.637",
  "quartz-auth": "/quartz-auth/static-1.1323",
  "quartz-head": "/quartz-head/static-1.1313",
  "quartz-i18n": "/quartz-i18n/static-1.1323",
  "quartz-routing": "/quartz-routing/static-1.1078",
  "quartz-test": "/quartz-test/static-1.1323",
  "quartz-tracking": "/quartz-tracking/static-1.1027",
  "trellis-components": "/trellis-components/static-1.3088",
  "ui-fonts": "/ui-fonts/static-1.1221",
  "usage-tracker-container": "/usage-tracker-container/static-1.7783",
  "usage-tracker-core": "/usage-tracker-core/static-1.7643",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.359",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "reference-resolvers": "/reference-resolvers/static-1.8652",
  "sanitize-text": "/sanitize-text/static-1.8629",
  "PatternValidationJS": "/PatternValidationJS/static-1.3356",
  "ReduxMessenger": "/ReduxMessenger/static-2.10840",
  "outpost": "/outpost/static-1.4600",
  "rpc-client-utils": "/rpc-client-utils/static-1.5141",
  "sanitize": "/sanitize/static-1.4944",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5011",
  "floating-ui": "/floating-ui/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9894",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3069",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3442",
  "foundations-theming-base": "/foundations-theming-base/static-1.3944",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.398",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.171",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10009",
  "atom": "/atom/static-1.5543",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8415",
  "ContentUtils": "/ContentUtils/static-1.69459",
  "data-token-picker": "/data-token-picker/static-1.17126",
  "file-manager-components": "/file-manager-components/static-1.24827",
  "FileManagerCore": "/FileManagerCore/static-1.40326",
  "FileManagerLib": "/FileManagerLib/static-1.40467",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8391",
  "hub-http-contrib": "/hub-http-contrib/static-1.3501",
  "interframe": "/interframe/static-3.5211",
  "layout-dnd-components": "/layout-dnd-components/static-1.13219",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12194",
  "property-translator": "/property-translator/static-1.5850",
  "react-codemirror": "/react-codemirror/static-1.11111",
  "react-colorpicker": "/react-colorpicker/static-2.10680",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8580",
  "rich-text-lib": "/rich-text-lib/static-1.20544",
  "tinymce-data": "/tinymce-data/static-1.41472",
  "tinymce-themes": "/tinymce-themes/static-1.57357",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10333",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5673",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16931",
  "bender-build-tools": "/bender-build-tools/static-1.3567",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10892",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10890",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5479",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "trellis-theming": "/trellis-theming/static-1.1469",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.551",
  "chirp-fetch": "/chirp-fetch/static-1.2374",
  "stylex-utils": "/stylex-utils/static-1.173",
  "chatspot-core": "/chatspot-core/static-1.23837",
  "copilot-toolkit": "/copilot-toolkit/static-1.12136",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13505",
  "data-fetching-client": "/data-fetching-client/static-1.10110",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5229",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9093",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29579",
  "usage-tracker": "/usage-tracker/static-1.7793",
  "cms-field-types": "/cms-field-types/static-1.5282",
  "content-icons-ui": "/content-icons-ui/static-1.2453",
  "integrations-lib": "/integrations-lib/static-1.17420",
  "customer-data-objects": "/customer-data-objects/static-1.8172",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2145",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5058",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4613",
  "poll-commands": "/poll-commands/static-1.3947",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9545",
  "video-components-external": "/video-components-external/static-1.12420",
  "video-data-lib": "/video-data-lib/static-1.36078",
  "audio-components": "/audio-components/static-1.6562",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.924",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30053",
  "FileManagerImages": "/FileManagerImages/static-1.37978",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1767",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.728",
  "ui-universal-auth": "/ui-universal-auth/static-1.9727",
  "urlinator": "/urlinator/static-1.4986",
  "video-components": "/video-components/static-1.14422",
  "video-embed": "/video-embed/static-1.36912",
  "ts-schema": "/ts-schema/static-1.4391",
  "ContentData": "/ContentData/static-1.69534",
  "layout-data-lib": "/layout-data-lib/static-1.10519",
  "react-dnd-compat": "/react-dnd-compat/static-1.5082",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2017",
  "external-options-client-types": "/external-options-client-types/static-1.4438",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6063",
  "hs-resources": "/hs-resources/static-1.664",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4150",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3531",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11618",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5904",
  "magpie-types": "/magpie-types/static-1.5364",
  "simple-logging-lib": "/simple-logging-lib/static-1.3522",
  "avatar-components": "/avatar-components/static-1.2957",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10306",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7054",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5351",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14835",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6090",
  "laboratory-lib": "/laboratory-lib/static-3.7618",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8233",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10748",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1123",
  "breeze-engine-core": "/breeze-engine-core/static-1.1423",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1117",
  "navigation-messaging": "/navigation-messaging/static-1.8484",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13582",
  "content-media-compositions": "/content-media-compositions/static-2.17589",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19632",
  "nudge-client-utils": "/nudge-client-utils/static-1.3411",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.291",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1523",
  "social-insights-client-types": "/social-insights-client-types/static-1.22918",
  "advanced-menus-core": "/advanced-menus-core/static-1.15809",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12565",
  "ExportDialog": "/ExportDialog/static-6.10842",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35171",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4111",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4441",
  "event-emitter": "/event-emitter/static-1.1433",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.482",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4333",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4006",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6225",
  "reactive-lib": "/reactive-lib/static-1.1191",
  "trellis-migration-context": "/trellis-migration-context/static-1.49",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.810",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3481",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.620",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30794",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3168",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3487",
  "onboarding-tours": "/onboarding-tours/static-1.17393",
  "whisper-core-api": "/whisper-core-api/static-1.7625",
  "fsm": "/fsm/static-1.4230",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15808",
  "simple-menus-lib": "/simple-menus-lib/static-1.17325",
  "settings-ui-lib": "/settings-ui-lib/static-1.12999",
  "persist-promise": "/persist-promise/static-1.4174",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7363",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10406",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19552",
  "growth-data-modal": "/growth-data-modal/static-1.6128",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2974",
  "navigation-components": "/navigation-components/static-1.19157",
  "nest": "/nest/static-1.706",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5608",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1460",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8129",
  "user-context": "/user-context/static-1.5524",
  "react-flip-move": "/react-flip-move/static-1.83",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7268",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2834",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3002",
  "user-context-client": "/user-context-client/static-1.4981",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18670",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15834",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8088",
  "onboarding-scopes": "/onboarding-scopes/static-1.6923"
}
};
